import styled, { css } from 'styled-components';

import { grey10 } from 'approot/shared/styles/colours.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { rem } from 'approot/shared/style';
import {
  RichtextProps,
  richtextCommonCss,
} from 'approot/shared/richtext/richtext.style';

type InfoTextBoxProps = {
  $width?: number | null;
} & RichtextProps;

export const baseCss = css<InfoTextBoxProps>`
  border: none;
  border-radius: ${rem(borderRadius8)};
  color: ${grey10};
`;

export const InfoTextBox = styled.div<InfoTextBoxProps>`
  ${baseCss}
  ${richtextCommonCss}
  max-width: ${({ $width }) => $width || 100}%;
  width: 100%;
`;

export const InfoTextBoxEdit = styled(InfoTextBox)``;
